// This is the single entry point for the webpack bundle.

// Basically, anything that isn't imported here or by a module
// imported here, won't be included in the final js.

// We import all the riot mixins and do the initialization

import bus from './core/events/bus';
import cookie from './core/mixins/cookie';
import storage from './core/mixins/storage';
import sharedObservable from './core/mixins/sharedObservable';
import content from './core/mixins/content';

// And import all the tags

// Components: Blind tags to render info
import './components/raq-vehicle-card/raq-vehicle-card.tag';
import './components/raq-select-vehicle/raq-select-vehicle.tag';
import './components/raq-raw-html/raq-raw-html.tag';
import '@acura/shared-components/src/components/acr-svg/acr-svg.tag';

// Containers: Handle data retrieving and manipulation
import './containers/raq-wrapper/raq-wrapper.tag';
import './containers/raq-vehicle-container/raq-vehicle-container.tag';
import './containers/raq-form/raq-form.tag';
import './containers/raq-dealer-container/raq-dealer-container.tag';

const AcrCookie = cookie;
const zipgateElement = document.getElementsByClassName('js-zipgate')[0];
const raqWrapper = document.getElementsByTagName('raq-wrapper')[0];

if (!window.console) {
  window.console = {};
}

if (raqWrapper) {
  if (window.Acr
    && window.Acr.zipgateComponent
    && !AcrCookie.cookie.get('zipcode')) {
    zipgateElement.setAttribute('data-redirect', 'true');
    // The openZipgate functionality is in the "acr-dealer-locator" index.js file.
  }
}

module.exports = {
  init: function init() {
    riot.mixin('bus', sharedObservable(bus(riot)));
    riot.mixin('cookie', AcrCookie);
    riot.mixin('storage', storage);
    riot.mixin(content.content());
    if (window.Utility) {
      window.Utility.svgLoader('/Areas/AcuraPlatform/icons/systems.svg');
    }
    return riot.mount('raq-wrapper')[0];
  },
};
